// --------------------------
// IMPORTS
// --------------------------
import { useSelector } from "react-redux";
import TopContainerHeader from "../../components/molecules/TopComponentHeader";
import { useState } from "react";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function Settings() {
  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeRole = useSelector((state) => state.auth.role);

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <div className="container">
      <div className="bgi-no-repeat card-stretch gutter-b rounded-lg p-0">
        <TopContainerHeader
          sectionNameClass="col-lg-7 text-left commonTitleText"
          sectionTitle="Settings"
          hasSectionButton={
            storeRole === process.env.REACT_APP_SROLE ? true : false
          }
          hasSearch={false}
          addNewButtonClassName="btn mx-auto px-5 py-2 defaultbutton rounded-lg"
          name="Import bulk data"
          onButtonClick={() => setIsAddModalOpen(true)}
          addFormModalOpen={isAddModalOpen}
          addFormSetIsModalOpen={setIsAddModalOpen}
          addFormModalShowLoader={setShowLoader}
        />
      </div>
    </div>
  );
}
